import React from 'react'
import Card from 'card'

const Websites = React.createClass({
	render() {
		return (
			<div id="websites" className="tab">
				<Card
					src="./img/portfolio/websites/iracing.jpg"
					name="iRacing (in development)"
					designed
					coded
					logo
					disabled
					descriptionType="ReactJS + Coherent UI app"
					buttonText="Under Development"
				/>
				<Card
					src="./img/portfolio/websites/dr-norma-colletta-dmdpc.jpg"
					name="Dr. Norma Colletta, DMD PC"
					designed
					coded
					logo
					disabled
					buttonText="Under Development"
				/>
				<Card
					src="./img/portfolio/websites/t206.jpg"
					name="T206 Investments"
					designed
					coded
					logo
					disabled
					buttonText="Under Development"
				/>
				<Card
					src="./img/portfolio/websites/tignj.jpg"
					name="The Insulation Heating and Cooling Group"
					href="http://tignj.com"
					designed
					coded
				/>
				<Card
					src="./img/portfolio/websites/rocks.jpg"
					name="ROCKs"
					href="http://cookwithrocks.org"
					designed
					coded
					disabled
					buttonText="Under Development"
				/>
				<Card
					src="./img/portfolio/websites/stratos.jpg"
					name="Seastreet: StratOS"
					href="http://seastreet.com"
					designed
					coded
					logo
				/>
				<Card
					src="./img/portfolio/websites/larche-boston-north.jpg"
					name="L'Arche Boston North"
					href="http://larchebostonnorth.org"
					designed
					coded
				/>
				<Card
					src="./img/portfolio/websites/madison-security-group.jpg"
					name="Madison Security Group"
					designed
					coded
					disabled
					buttonText="Under Development"
				/>
				<Card
					src="./img/portfolio/websites/schumacher-and-farley.jpg"
					name="Schumacher and Farley Home Services"
					href="http://schumacherandfarleyhomeservices.com"
					designed
					coded
				/>
				<Card
					src="./img/portfolio/websites/mann-orchards.jpg"
					name="Mann Orchards"
					href="http://mannorchards.com"
					designed
					coded
				/>
				<Card
					src="./img/portfolio/websites/troops-to-trades.jpg"
					name="Troops to Trades"
					href="http://troopstotrades.org"
					designed
					coded
				 />
				<Card
					src="./img/portfolio/websites/granite-state-games.jpg"
					name="The Granite State Games"
					href="http://granitestategames.org"
					designed
					coded
					logo
				 />
				<Card
					src="./img/portfolio/websites/the-virgin-olive.jpg"
					name="The Virgin Olive"
					href="http://virginolivegourmet.com"
					designed
					coded
					logo
				 />
				<Card
					src="./img/portfolio/websites/explore-the-trades.jpg"
					name="Explore the Trades"
					href="http://explorethetrades.org"
					designed
					coded
					logo
				 />
				<Card
					src="./img/portfolio/websites/in-the-net.jpg"
					name="In The Net Sports Academy"
					href="http://inthenetsportsacademy.com"
					designed
					coded
				 />
				<Card
					src="./img/portfolio/websites/futsal-new-york.jpg"
					name="Futsal New York"
					href="http://futsalnewyork.com"
					designed
					coded
					logo
				 />
				<Card
					src="./img/portfolio/websites/tombarello.jpg"
					name="Tombarello and Sons"
					href="http://tombarello.com"
					designed
					coded
				 />
				<Card
					src="./img/portfolio/websites/windfield.jpg"
					name="Windfield Alloy"
					href="http://windfieldalloy.com"
					designed
					coded
				 />
				<Card
					src="./img/portfolio/websites/bonafide-home-inspections.jpg"
					name="Bonafide Home Inspections"
					href="http://bonafidehomeinspections.com"
					designed
					coded
					logo
				 />
				<Card
					src="./img/portfolio/websites/west-end-design-concepts.jpg"
					name="West End Design Concepts"
					href="http://westenddesignconcepts.com"
					designed
					coded
				 />
				<Card
					src="./img/portfolio/websites/the-sanctuary.jpg"
					name="The Sanctuary Spa"
					href="http://sanctuarysalem.com"
					designed
					coded
				 />
				<Card
					src="./img/portfolio/websites/ashleys-collection.jpg"
					name="Ashley's Collection"
					href="http://hallmarkgc.com"
					designed
					coded
					logo
				 />
				<Card
					src="./img/portfolio/websites/thechapelschool.jpg"
					name="The Chapel School"
					href="http://chapelkids.com"
					designed
					coded
				 />
			</div>
		)
	}
});

module.exports = Websites;